module.exports = __webpack_public_path__ + "img/hotel-ibis-lisboa-centro-liberdade.a3fdc848.jpg";